import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';

import { tenantApiPriceRowSchema } from '../schemas/pricingSchemas';
import { pricingKeys } from './pricingKeys';

// Reads the super-admin pricing grid — every offered API's Studio price for every
// tenant. Read-only; prices are maintained in Console and refreshed via useSyncPricing.
export function useApiPricing() {
  return useQuery({
    queryKey: pricingKeys.list(null),
    queryFn: async ({ signal }) => {
      const raw = await apiClient.get('api/v1/admin/pricing', { signal }).json();
      return tenantApiPriceRowSchema.array().parse(raw);
    },
    staleTime: 60 * 1000,
  });
}
